<template>
  <div>
    <OverlayLoading :loading="loading" />
    <div>
      <v-data-table
        class="border-table-business text-no-wrap mt-1"
        item-key="no"
        :headers="headers"
        :items="dataSource"
        :loading="loading"
        :expanded.sync="expanded"
        loader-height=0
        loading-text="Loading... Please wait"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100, -1],
          'items-per-page': 15
        }"
        :server-items-length="total || -1"
        @update:items-per-page="changePerPage"
        @update:page="changePage"
        :page.sync="page"
        :items-per-page="perPage"
        hide-default-footer
        @page-count="pageCount = $event"
      >
        <!-- <template v-slot:[`item.no`]="{ item }">
          {{ (perPage*(page-1)) + dataSource.indexOf(item)+1 }}
        </template> -->
        <template v-slot:[`item.companyImage`]="{ item }">
          <td style="width: fit-content !important;" class="py-2">
            <v-avatar
              size="50"
              rounded
            >
              <v-img
                contain
                :lazy-src="require('@/assets/icons/company-logo3.png')"
                :src="item.failed_image ? require('@/assets/icons/company-logo3.png') : item.companyImage"
                :alt="item.employeeId"
                v-on:error="onImgError(item.no-1)"
                aspect-ratio="2.7"
              />
            </v-avatar>
          </td>
        </template>
        <!-- ### ความน่าเชื่อถือ ### -->
        <!-- <template v-slot:[`item.reliability`]="{ item }">
          <span>
            <v-icon
                :color="item.reliability <= 30 ? '#F37959' : item.reliability > 30 && item.reliability <= 61 ? '#F2BE47' : item.reliability > 61 && item.reliability <= 79 ? '#3D5D85' : '#6FB540'"
                class="pl-0"
                large
              >
                mdi-circle-small
              </v-icon>
            {{ item.reliability }} คะแนน
            </span>
        </template> -->
        <!-- ### สถานะใบคำร้อง ### -->
        <template v-slot:[`item.validation`]="{ item }">
          <v-chip
            :color="item.validation == true ? '#ECF8EA' : item.validation == false ? '#FBE5E4':'#ECF9FF'"
            :text-color="item.validation == true ? '#58A144' : item.validation == false ? '#D1392B':'#ECF9FF'"
          >
            <span>{{ item.validation == true ? 'ผ่าน' : item.validation == false ? 'ไม่ผ่าน' :'-'}}</span>
          </v-chip>
        </template>
        <!-- ### สถานะคำร้อง ### -->
        <template v-slot:[`item.status`]="{ item }">
          <v-chip
            :color="item.status == 'approved' || item.status == 'acknowledge' ? '#ECF8EA' : item.status == 'reject' || item.status == 'denied' ? '#FBE5E4' : item.status == 'pending' ? '#FEF5E9' : item.status == 'cancel' ? '#F5F5F5':'#ECF9FF'"
            :text-color="item.status == 'approved' || item.status == 'acknowledge' ? '#58A144' : item.status == 'reject' || item.status == 'denied' ? '#D1392B' : item.status == 'pending' ? '#E9A016' : item.status == 'cancel' ? '#757575':'#ECF9FF'"
          >
            <span>{{ item.status == 'approved' || item.status == 'acknowledge' ? 'อนุมัติ' : item.status == 'reject' || item.status == 'denied' ? 'ไม่อนุมัติ' : item.status == 'pending' ? 'รออนุมัติ' : item.status == 'cancel' ? 'ยกเลิก':'-'}}</span>
          </v-chip>
        </template>
        <!-- ### สถานะคำร้อง v.1 ### -->
        <template v-slot:[`item.type`]="{ item }">
          <v-chip
          outlined
          :color="item.type == 'create' ? '#3776E9' : item.type == 'edit' ? '#E9A016': item.type == 'delete' ? '#D1392B':'#ECF9FF'"
          :text-color="item.type == 'create' ? '#3776E9' : item.type == 'edit' ? '#E9A016': item.type == 'delete' ? '#D1392B': '#ECF9FF'"
          >
          <span>{{ item.type == 'create' ? 'สร้างธุรกิจ' : item.type == 'edit' ? 'แก้ไขธุรกิจ' : item.type == 'delete' ? 'ลบธุรกิจ': '-' }}</span>
        </v-chip>
        </template>
        <!-- ### สถานะคำร้อง v.2 ### -->
        <!-- <template v-slot:[`item.type`]="{ item }">
          <v-chip
          :color="item.type == 'create' ? '#ECF9FF' : item.type == 'edit' ? '#FEF5E9': item.type == 'delete' ? '#FBE5E4':'#ECF9FF'"
          :text-color="item.type == 'create' ? '#3776E9' : item.type == 'edit' ? '#E9A016': item.type == 'delete' ? '#D1392B': '#ECF9FF'"
          >
          <span>{{ item.type == 'create' ? 'สร้าง' : item.type == 'edit' ? 'แก้ไข' : item.type == 'delete' ? 'ลบ': '-' }}</span>
        </v-chip>
        </template> -->
        <!-- ### สถานะแก้ไข เก่า ### -->
        <!-- <template v-slot:[`item.isEdit`]="{ item }">
          <v-chip
          outlined
          :color="item.isEdit == true ? '#E9A016' : item.isEdit == false ? '#58A144':'#ECF9FF'"
          :text-color="item.isEdit == true ? '#E9A016' : item.isEdit == false ? '#58A144':'#ECF9FF'"
          >
          <span>{{ item.isEdit == true ? 'มีการแก้ไข' : item.isEdit == false ? 'ไม่มีการแก้ไข' : '-' }}</span>
        </v-chip>
        </template> -->
        <!-- <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                rounded
                dark
                icon
                class="mt-3 mb-3 ml-2"
                @click="view(item)"
              >
              <v-icon color="#2BA197" class="ml-auto">mdi-eye</v-icon>
              </v-btn>
            </template>
            <span class="label-table-action">ดูรายละเอียด</span>
          </v-tooltip>
        </template> -->
        <template v-slot:[`item.data-table-expand`]="{ item }">
          <v-row class="d-flex px-4">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  rounded
                  dark
                  icon
                  class="mt-3 mb-3 ml-4"
                  @click="view(item)"
                >
                <v-icon color="#2BA197" class="ml-auto">mdi-eye-outline</v-icon>
                <!-- <img width="20" height="10" src="@/assets/icons/eye-view.png" > -->
                </v-btn>
              </template>
              <span class="label-table-action">ดูรายละเอียด</span>
            </v-tooltip>
          </v-row>
        </template>
      </v-data-table>
      <v-row>
      <v-col cols="12" class="pa-0">
      <div class="justify-end d-flex align-end pt-4">
        <v-pagination
          v-model="page"
          :length="pageCount"
          :total-visible="5"
        ></v-pagination>
      </div>
      </v-col>
    </v-row>
    </div>
    <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        :color="snackbarColor"
        text
        top
        app
      >
        <v-icon left dark small :color="snackbarColor">fa-check-circle</v-icon>
        <span :style="{ color: `${snackbarColor}` }">{{ text }}</span>
      </v-snackbar>
    <!-- ### snackbar(เก่า) ### -->
    <!-- <v-snackbar
      v-model="snackbar"
      :timeout="2000"
      top
      centered
      elevation="1"
      color="#ECF8EA"
      app
    >
      <v-icon dark color="#58A144" >mdi-check-circle-outline</v-icon>
      <span style="font-family: Sarabun; font-style: normal; font-weight: 400; font-size: 16px; line-height: 22px; text-align: center; color: #58A144;">
        {{ workfor=='approve'? 'คุณได้ทำการอนุมัติคำร้องเรียบร้อย':'คุณได้ทำการไม่อนุมัติคำร้องเรียบร้อย' }}
      </span>
    </v-snackbar> -->
  </div>
</template>

<script>
import { EventBus } from '@/EventBus'
import OverlayLoading from '../../_template/OverlayLoading.vue'
import { fetchAllRequestManageApproveBusiness } from '@/API/API'
const moment = require('moment')
export default {
  name: 'tree',
  components: {
    OverlayLoading
  },
  props: {
    mode: String
  },
  data () {
    return {
      expanded: [],
      dialog: false,
      workfor: 'approve',
      comment: '',
      timeout: 2000,
      snackbarColor: '',
      snackbar: false,
      text: '',
      // isAdmin: localStorage.approveRole === 'Super Admin' ? localStorage.approveRole === 'Super Admin' : false,
      isAdmin: this.$store.state.user.role[1].permission === 'Super Admin' ? this.$store.state.user.role[1].permission === 'Super Admin' : false,
      singleSelect: false,
      allowBtnApprove: false,
      allowBtnReject: false,
      loading: false,
      filterData: {
        // businessType: '',
        statusType: '', // status
        registerType: '', // reg type
        reqEmployeeNo: '',
        employeeName: '',
        companyName: [],
        position: [],
        requestType: [],
        status: [],
        isEdit: [], // สถานะแก้ไข
        type: [], // สถานะคำร้อง
        approveType: this.mode,
        createAt: '',
        updateAt: '',
        limit: 15,
        page: 1
      },
      textBtnOk: this.mode === 'approve' ? 'อนุมัติ' : 'รับทราบ',
      textBtnNO: this.mode === 'approve' ? 'ไม่อนุมัติ' : 'ไม่รับทราบ',
      statusList: [
        // { status: 'pending', statusTH: 'กำลังดำเนินการ', color: '#00B0FF' },
        { status: 'pending', statusTH: 'รออนุมัติ', color: '#E9A016' },
        { status: 'approved', statusTH: 'อนุมัติแล้ว', color: '#58A144' },
        { status: 'reject', statusTH: 'ไม่อนุมัติ', color: '#D1392B' },
        { status: 'cancel', statusTH: 'ยกเลิก', color: '#757575' },
        { status: 'acknowledge', statusTH: 'รับทราบแล้ว', color: '#58A144' }
      ],
      headers: [
        // {
        //   text: 'ลำดับ',
        //   align: 'center',
        //   value: 'no',
        //   width: '65',
        //   sortable: false
        // },
        { text: 'สถานะใบรับรอง', value: 'validation', sortable: false, align: 'center' },
        { text: 'หมายเลขคำร้อง', value: 'requestNo', sortable: false },
        { text: 'รูปภาพ', value: 'companyImage', sortable: false },
        // { text: 'รูปภาพ', value: 'companyImage', width: '15%' },
        { text: 'ชื่อเต็มธุรกิจ', value: 'companyFullNameTh', sortable: false },
        { text: 'รูปแบบธุรกิจ', value: 'businessModelType', sortable: false },
        { text: 'ประเภทการลงทะเบียน', value: 'registerType', sortable: false },
        { text: 'วันที่สร้าง', value: 'createAt', sortable: true },
        { text: 'วันที่แก้ไขล่าสุด', value: 'updateAt', sortable: true },
        { text: 'สถานะ', value: 'status', sortable: false, align: 'center' },
        // { text: 'สถานะคำร้อง', value: 'isEdit', sortable: false }, // สถานะคำร้องเก่า
        { text: 'สถานะคำร้อง', value: 'type', sortable: false, align: 'center' }, // สถานะคำร้องใหม่
        { text: 'จัดการ', value: 'data-table-expand', sortable: false, width: '120px', align: 'center fixed', class: 'column-fix' }
        // { text: 'รูปแบบธุรกิจ', value: 'businessType' },
        // { text: 'คะแนนความน่าเชื่อถือ', value: 'reliability' },
        // { text: 'ชื่อ-นามสกุล', value: 'userFullNameTh' },
        // { text: 'บริษัท', value: 'companyName' },
        // { text: 'เวลาที่ร้องขอ', value: 'createAt' },
        // { text: 'สถานะคำร้อง', value: 'requestStatus', width: '15%' },
        // { text: '', width: '5%', value: 'actions', sortable: false, align: 'center fixed', class: 'column-fix' }

      ],
      checkBtnRehister: false,
      dataSource: [],
      // ทดสอบข้อมูล (requestStatus) 19/06/66
      dataSourcetest: [
        {
          no: '1',
          requestStatus: 'pass',
          requestNo: 'test001',
          companyFullNameTh: 'ทดสอบ1',
          businessModelType: 'ทดสอบนะ',
          registerType: 'unknow',
          status: 'approved',
          type: 'create'
        },
        {
          no: '2',
          requestStatus: 'notpass',
          requestNo: 'test002',
          companyFullNameTh: 'ทดสอบ2',
          businessModelType: 'ทดสอบนะ',
          registerType: 'unknow',
          status: 'reject',
          type: 'create'
        }
      ],
      serviceTypeList: [],
      requestStatusList: [],
      total: -1,
      perPage: 15,
      pageCount: 0,
      page: 1,
      textCondition: {
        new: 'เพิ่มบุคคล',
        transfer: 'ขอย้ายฝ่าย',
        resign: 'ขอลาออก',
        transferPosition: 'ย้ายตำแหน่ง',
        resignPosition: 'ลาออกจากตำแหน่ง',
        resignEmployee: 'ลาออกจากบริษัท'
      },
      approveRole: localStorage.approveRole

    }
  },
  async created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    await this.initData()
  },
  mounted () {
    EventBus.$on('manageApproveMarketSearch', this.getSelect)
  },
  beforeDestroy () {
    EventBus.$off('manageApproveMarketSearch')
  },
  methods: {
    onImgError (i) {
      this.dataSource[i].failed_image = true
    },
    changePerPage (value) {
      this.perPage = value
      this.initDataTable()
    },
    changePage (value) {
      this.page = value
      this.initDataTable()
    },
    async getSelect (data) {
      this.filterData = data
      this.keywordCompanyName = data.companyName
      this.keywordGroupCompanyName = data.groupCompany
      this.total = -1
      this.perPage = 15
      this.page = 1
      await this.initData()
    },
    initData () {
      // this.initSelectData()
      this.initDataTable()
    },
    async initDataTable () {
      this.loading = true
      this.dataSource = []
      const self = this
      const temp = []
      var statusType = ''
      if (this.filterData.status === undefined) {
        statusType = ''
      } else {
        statusType = this.filterData.status[0]
      }
      var obj = {
        businessModelTap: this.filterData.businessModelTap,
        // reqBusinessNo: this.filterData.reqCompanyNo || '',
        name: '', // ชื่อธุรกิจ
        businessModelType: 'market', // ประเภทธุรกิจ
        businessType: this.filterData.businessType || [],
        // _id: this.filterData.searchNameAndEmpId || [],
        type: 'all', // tab ลงทะเบียนให้ส่ง create ไป
        companyId: this.filterData.searchNameAndEmpId || '',
        role: this.filterData.role || this.approveRole,
        registerType: this.filterData.registerType || '',
        status: statusType || '', // สเตตัส 'waiting', 'pending', 'approve', 'denied'
        createAt: this.filterData.createAt || '',
        updateAt: this.filterData.updateAt || '',
        limit: this.perPage,
        page: this.page
      }
      // console.log('filterData', obj)
      const token = this.tokenUser

      try {
        // const res = await fetchAllRequestManageBusiness(obj, token) //เส้นเดิม
        const res = await fetchAllRequestManageApproveBusiness(obj, token) // เส้นใหม่
        if (res.success) {
          res.result.map((el, index) => {
            el.companyImage = `${this.api}/api/vMonk/companys/getcompanyFileById/` + el.companyImage
            // el.businessModelType = el.businessModelType === 'market' ? 'ธุรกิจร้านค้า' : 'นิติบุคคล'
            if (el.businessModelType === 'market') {
              el.businessModelType = 'ธุรกิจร้านค้า'
            } else if (el.businessModelType === 'corporation') {
              el.businessModelType = 'นิติบุคคล'
            } else {
              el.businessModelType = 'องค์กร'
            }
            if (el.registerType === 'registerFull') {
              el.registerType = 'ลงทะเบียนธุรกิจฉบับเต็ม'
            } else {
              el.registerType = 'ลงทะเบียนธุรกิจฉบับย่อ'
            }
            temp.push({
              no: index + 1,
              failed_image: false,
              ...el
            })
          })
          this.total = res?.count || -1
          this.dataSource = temp
          self.computeData(self.dataSource)
        } else {
          this.dataSource = []
        }
      } catch (error) {
        // alert(error)
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async computeData (item) {
      await item.map(e => {
        e.createAt = moment(e.createAt).format('DD/MM/YYYY HH:mm น.')
        e.updateAt = moment(e.updateAt).format('DD/MM/YYYY HH:mm น.')
      })
    },
    view (item) {
      this.$router.push({
        name: 'manageapproveBusinessupdate',
        params: {
          status: item.status,
          reliable: item.reliable,
          id: item.companyId,
          _id: item._id,
          comment: item.comment,
          isEdit: item.isEdit
        }
      })
      // this.$router.push('manageapprovebusiness/update/' + item.companyId)
    }
  }
}
</script>

<style scoped>
.v-data-table {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 16px;
}
.row-menu-left {
  justify-content: flex-start !important;
}
.row-menu-right {
  justify-content: flex-end !important;
}
.v-data-table tbody tr.v-data-table__expanded__content {
  box-shadow: inset 0px 4px 8px -5px rgba(50, 50, 50, 0), inset 0px -4px 8px -5px rgba(50, 50, 50, 0) !important;
}
.padding-left-90 {
  padding-left: 90px !important;
}
.table-name-row {
  display: flex;
  flex-direction: row;
}
.btn-edit-dep {
  background-color: #0370B7 !important;
  color: #fff !important;
}
.btn-del-dep {
  background-color: #da2525 !important;
  color: #fff !important;
}

.border-table-business {
  border-radius: 10px;
  border: 1px solid rgb(229, 236, 238);
}

table > tbody > tr > td.fixed:nth-last-child(1),
table > thead > tr > th.fixed:nth-last-child(1) {
  position: sticky !important;
  position: -webkit-sticky !important;
  right: 0;
  /* z-index: 9997; */
  background: white;
  /* background: transparent; */
  -webkit-box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
  -moz-box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
  box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
}

table > tbody > tr:hover > td.fixed:nth-last-child(1), table > thead > tr:hover > th.fixed:nth-last-child(1) {
  background: #eeeeee;
}

table > thead > tr > th.fixed:nth-last-child(1) {
  /* z-index: 9998; */
  background-color: #F8F9FB;
}
/* table */
.theme--light.v-pagination .v-pagination__item--active {
    background: #2BA197 !important;
    color: #FFFFFF;
}
.v-pagination__item {
    background: transparent;
    border-radius: 4px;
    font-size: 14px;
    height: 30px;
    margin: 0.3rem;
    min-width: 30px;
    padding: 0 5px;
    text-decoration: none;
    transition: 0.3s cubic-bezier(0, 0, 0.2, 1);
    width: auto;
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
}
.v-pagination__navigation {
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    height: 30px;
    width: 30px;
    margin: 0.3rem 10px;
}
/* end */
</style>
